"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Percentage.css");

var _react = _interopRequireDefault(require("react"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(_ref) {
  var index = _ref.index,
      _ref$superScript = _ref.superScript,
      superScript = _ref$superScript === void 0 ? "" : _ref$superScript;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "percentage-section"
  }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    contentKey: "percentage-".concat(index),
    tag: "div",
    className: "percentage"
  }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    contentKey: "details-".concat(index),
    tag: "p",
    className: "details ".concat(superScript)
  }));
};

exports.default = _default;